/** Service worker offline retiré — heartbeats passent par beacon / fetch direct vers la DB. */
export default defineNuxtPlugin(() => {})
